import {alpha} from '@mui/material/styles'

export interface SyskronPalette {
    common: {
        itemHover: string
        itemSelected: string
        textBlue: string
        textGrey: string
        textDarkBlue: string
        textLightBlue: string
        textLightGrey: string
        textMediumGrey: string
        textBlack: string
        green: string
        yellow: string
        orange: string
        red: string
        greenContrast: string
        yellowContrast: string
        orangeContrast: string
        redContrast: string
    }
    colors: {
        P50: string
        P100: string
        P200: string
        P300: string
        P400: string
        P500: string
        P600: string
        P700: string
        P800: string
        P900: string
        S50: string
        S100: string
        S200: string
        S300: string
        S400: string
        S500: string
        S600: string
        S700: string
        S800: string
        S900: string
        W50: string
        W100: string
        W200: string
        W300: string
        W400: string
        W500: string
        W600: string
        W700: string
        W800: string
        W900: string
        newGreen: string
        newRed: string
    }
    contrastColors: {
        P50: string
        P100: string
        P200: string
        P300: string
        P400: string
        P500: string
        P600: string
        P700: string
        P800: string
        P900: string
        S50: string
        S100: string
        S200: string
        S300: string
        S400: string
        S500: string
        S600: string
        S700: string
        S800: string
        S900: string
        W50: string
        W100: string
        W200: string
        W300: string
        W400: string
        W500: string
        W600: string
        W700: string
        W800: string
        W900: string
        newGreen: string
        newRed: string
    }
}

const syskronColors = {
    colors: {
        P50: '#FFFFFF', // X1 White for Cards/Backgrounds
        P100: '#E5EFFA', // SP1 used for secondary buttons background
        P200: '#C7DDED', // Comment
        P300: '#A9CAE0', // SP7
        P400: '#57B5DE', // Comment
        P500: '#059FDC', // SP13 SyskronColor
        P600: '#0082C8', // SP19
        P700: '#0060ad', // SP25 KronesBlue
        P800: '#03458B', // Comment
        P900: '#052A68', // SP31
        S50: '#FFFFFF', // X2 White for Menus/Dialogs
        S100: '#F7F7F7', // GP1 Background Color
        S200: '#E0E1E2', // Comment
        S300: '#C9CBCC', // Comment
        S400: '#B2B5B7', // GP7
        S500: '#959BA0', // Comment
        S600: '#79828A', // Comment
        S700: '#5C6873', // GP13
        S800: '#2E343A', // Comment
        S900: '#000000', // G19
        W50: '#E5EFFA', // Syskron P100
        W100: '#059FDC', // Syskron P500
        W200: '#4EB17A', // New Blender
        W300: '#97C218', // Syskron Lookbook
        W400: '#CBD00C', // New Blender
        W500: '#FFDD00', // Syskron Lookbook
        W600: '#F19303', // New Blender
        W700: '#E34805', // Syskron Lookbook
        W800: '#E02C10', // New Blender
        W900: '#DD101A', // Syskron Lookbook
        newGreen: '#6AD913', // success
        newRed: '#FD313B' // error
    },
    contrastColors: {
        P50: '#0060ad', // X1 White for Cards/Backgrounds
        P100: '#0060ad', // SP1 used for secondary buttons background
        P200: '#0060ad', // Comment
        P300: '#0060ad', // SP7
        P400: '#FFFFFF', // Comment
        P500: '#FFFFFF', // SP13 SyskronColor
        P600: '#FFFFFF', // SP19
        P700: '#FFFFFF', // SP25 KronesBlue
        P800: '#FFFFFF', // Comment
        P900: '#FFFFFF', // SP31
        S50: '#5C6873', // S700
        S100: '#5C6873', // S700
        S200: '#5C6873', // S700
        S300: '#2E343A', // S800
        S400: '#2E343A', // S800
        S500: '#FFFFFF', // P / 50
        S600: '#FFFFFF', // P / 50
        S700: '#FFFFFF', // P / 50
        S800: '#FFFFFF', // P / 50
        S900: '#FFFFFF', // P / 50
        W50: '#0060ad', // P700 (SP25)
        W100: '#FFFFFF', // P50
        W200: '#2E343A', // S / 900
        W300: '#2E343A', // S / 900
        W400: '#2E343A', // S / 900
        W500: '#2E343A', // S / 900
        W600: '#2E343A', // S / 900
        W700: '#FFFFFF', // P / 50
        W800: '#FFFFFF', // P / 50
        W900: '#FFFFFF', // P / 50
        newGreen: '#2E343A', // success
        newRed: '#FFFFFF' // error
    }
}

export const syskronPalette = {
    common: {
        itemHover: alpha(syskronColors.colors.P500, 0.1),
        itemSelected: alpha(syskronColors.colors.P500, 0.3),
        textLightBlue: syskronColors.colors.P500,
        textBlue: syskronColors.colors.P700,
        textDarkBlue: syskronColors.colors.P900,
        textLightGrey: syskronColors.colors.S300,
        textMediumGrey: syskronColors.colors.S500,
        textGrey: syskronColors.colors.S700,
        textBlack: syskronColors.colors.S900,
        green: syskronColors.colors.W300,
        yellow: syskronColors.colors.W500,
        orange: syskronColors.colors.W700,
        red: syskronColors.colors.W900,
        greenContrast: syskronColors.contrastColors.W300,
        yellowContrast: syskronColors.contrastColors.W500,
        orangeContrast: syskronColors.contrastColors.W700,
        redContrast: syskronColors.contrastColors.W900
    },
    colors: syskronColors.colors,
    contrastColors: syskronColors.contrastColors
}
